const readyMovementsHashModal = () => {
  const modal = document.getElementById('modal-abono');
  if (!modal) return;

  const modalCloser = document.getElementById('modal-closer-abono');
  const lineMovements = document.querySelectorAll('.line-movement');

  lineMovements.forEach(movement => {
    const operation = movement.dataset.operation;
    if (operation === 'Abono' || operation === 'Deposit') {
      const bankMovementRawData = movement.dataset.bankMovementRawData;
      if (!bankMovementRawData) return;
      let regex = /"txId"=>"([^"]+)"/;
      let match = bankMovementRawData.match(regex);
      if (match) {
        let txId = match[1];
        movement.classList.add('clickable');
        movement.addEventListener('click', () => {
          document.getElementById('modal-abono-date').innerText = movement.dataset.date;
          document.getElementById('modal-abono-code').innerText = movement.dataset.code;
          document.getElementById('modal-abono-tx-id').innerText = txId;
          modal.style.display = 'flex';
        });
      }
    }
  });

  if (modalCloser) {
    modalCloser.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  }

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });
};

export default readyMovementsHashModal;
